import { useContext } from "react"
import { AppContext } from "../App"
import { MdDashboard, MdHome, MdLogout, MdMenu, MdNotifications, MdOutlineLocalPharmacy, MdOutlineMessage, MdOutlineNotifications } from "react-icons/md";
import { IoChatbubble, IoChatbubbles, IoNotificationsOutline, IoRefreshCircleOutline } from "react-icons/io5";
import { TbMessageDots } from "react-icons/tb";
import { callApi, setCookie } from "../Helpers";
import logo_worded_only from '../assets/logo_worded_only.png';
import { AiOutlineUser } from 'react-icons/ai';
import { STR_EXTRAS, STR_MENU_DATING, STR_MENU_DOCTORS, STR_MENU_HOME, STR_MENU_INBOX, STR_PHARMACY } from "../Strings";
import { RiHome6Fill, RiHomeLine } from 'react-icons/ri';
import { GiLovers, GiTalk } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";


export default function BottomBar(props) {

  const appContext = useContext(AppContext);

  return (
    <div
      className="BottomBar"
    >
      <div className="body d-flex">

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'home' || !appContext.navItem}
          onClick={() => {
            appContext.navTo({
              item: 'home',
            })
          }}
        >
          <RiHome6Fill className="mSymbol" />
          <h6 className="mText">{STR_MENU_HOME[appContext.language]}</h6>
        </div>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'dating'}
          onClick={() => {
            appContext.navTo({
              item: 'dating',
            })
          }}
        >
          <GiLovers className="mSymbol" />
          <h6 className="mText">{STR_MENU_DATING[appContext.language]}</h6>
        </div>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'doctors'}
          onClick={() => {
            appContext.navTo({
              item: 'doctors',
            })
          }}
        >
          <FaUserDoctor className="mSymbol" />
          <h6 className="mText">{STR_MENU_DOCTORS[appContext.language]}</h6>
        </div>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'pharmacy'}
          onClick={() => {
            appContext.navTo({
              item: 'pharmacy',
            })
          }}
        >
          <MdOutlineLocalPharmacy className="mSymbol" />
          <h6 className="mText">{STR_PHARMACY[appContext.language]}</h6>
        </div>

        <div
          className="mIcon text-center"
          data-active={appContext.navItem === 'inbox'}
          onClick={() => {
            appContext.navTo({
              item: 'inbox',
            })
          }}
        >
          <IoChatbubbles className="mSymbol" />
          <h6 className="mText">{STR_MENU_INBOX[appContext.language]}</h6>
        </div>

        

      </div>
    </div>
  )
}